import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'pr-panel-body',
    templateUrl: './pr-panel-body.component.html',
    styleUrls: ['./pr-panel-body.component.scss'],
    standalone: false
})
export class PrPanelBodyComponent {
  @Input() clazz: string;

  constructor() {}
}
